import { Tab } from "@headlessui/react";
import Layout from "../../components/global/layout";
import ChatBotTab from "./Tabs/ChatBotTab";
import DashboardTab from "./Tabs/DashboardTab";
import SourcesTab from "./Tabs/SourcesTab";
import SettingsTabs from "./Tabs/SettingsTabs";
import React, { useEffect, useState } from "react";
import { ChatbotProvider } from "./TabContextProvider";
 import methodModel from "../../methods/methods";
import { useSelector } from "react-redux";
import Widget from "../OmniChannel/Widget";


export default function Dashboard() {
  const SubscriptionData = useSelector(state => state.Subscription);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const tab = methodModel.getPrams("tab");

  useEffect(() => {
    if (tab === "chatlog") {
      setSelectedIndex(1);
    }
  }, [tab]);

  // Define the tab configuration with conditions
  const allTabs = [
        {
      name: "Add Sources",
      icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text size-4" data-fg-bnlv13="3.19:3.6060:/src/app/components/ChatbotSetup.tsx:70:19:2560:27:e:Icon"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>,
      component: <SourcesTab />,
      requiredSlugs: ["add-sources"],
    },

    {
      name: "Test Chatbot",
       icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square size-4" data-fg-bnlv13="3.19:3.6060:/src/app/components/ChatbotSetup.tsx:70:19:2560:27:e:Icon"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>,
      component: <ChatBotTab />,
      requiredSlugs: [],
    },
    {
      name: "Chat Logs",
       icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-column size-4" data-fg-bnlv13="3.19:3.6060:/src/app/components/ChatbotSetup.tsx:70:19:2560:27:e:Icon"><path d="M3 3v16a2 2 0 0 0 2 2h16"></path><path d="M18 17V9"></path><path d="M13 17V5"></path><path d="M8 17v-3"></path></svg>,
      component:<DashboardTab />,
      requiredSlugs: [],
    },
{
      name: "Widget",
       icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-code size-4" data-fg-bnlv13="3.19:3.6060:/src/app/components/ChatbotSetup.tsx:70:19:2560:27:e:Icon"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>,
      component:<Widget />,
      requiredSlugs: [], // one of these
    },


  ];  

  const visibleTabs = allTabs;

  return (
    <ChatbotProvider>
      <Layout>
        <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
        <div className="">
          <div className="max-xl:container xl:max-w-[1280px]  mx-auto">
        <div className="flex flex-col gap-1 mb-6">
          <h1 className="text-gray-900 text-xl sm:text-2xl font-semibold">Setup Chatbot</h1>
          <p className="text-sm sm:text-md text-gray-600">
            Setup Your Chatbot by Starting with Adding Resources
          </p>
        </div>

               
          <div className="border-b overflow-auto max-lg:[scrollbar-width:none] max-lg:[-ms-overflow-style:none] max-lg:[&::-webkit-scrollbar]:hidden">
            <Tab.List className="gap-2 flex border-gray-5">
              {visibleTabs.map((tab, index) => (
                <Tab
                  key={index}
                  className="flex items-center gap-2 py-3 sm:py-4 px-3 sm:px-6 text-sm sm:text-md text-gray-600 tracking-[0.2px] whitespace-nowrap leading-none border-b-2 border-transparent aria-selected:border-b-2 aria-selected:border-[#115B9D] hover:border-b-2 hover:border-gray-300 aria-selected:text-[#115B9D] outline-none capitalize"
                >
                  {tab?.icon?tab?.icon:null}
                  {tab.name}
                </Tab>
              ))}
            </Tab.List>
          </div>
          </div>
          </div>

        <div className="pt-8">
          <div className="max-xl:container xl:max-w-[1280px]  mx-auto">
    
           <div className="">
          <Tab.Panels>
            {visibleTabs.map((tab, index) => (
              <Tab.Panel key={index}>
      {typeof tab.component === "function" ? tab.component() : tab.component}
              </Tab.Panel>
            ))}
          </Tab.Panels>
                  </div> 
        </div>
        </div>
        </Tab.Group>
      </Layout>
    </ChatbotProvider>
  );
}
